import styled, { css } from 'styled-components';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { Typography } from '../../global/theme';
import { AlignCenter, FlexBetween, FlexCenter } from '../../global/commonStyle';

interface Props {
  isGap?: boolean;
}
export const Content = styled.div`
  padding: var(--space-20);
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  overflow-y: auto;
  ${mobile_xl(css`
    overflow-y: unset;
    padding-block: var(--space-8) var(--space-96);
  `)}
`;

export const ItemBlock = styled.div`
  ${mobile_xl(css`
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
  `)}
`;

export const Tasklist = styled.div<Props>`
  ${FlexBetween}
  margin-bottom: var(--space-2);

  ${(props: Props) =>
    props.isGap &&
    css`
      margin-top: var(--space-20);
    `}
  ${mobile_xl(css`
    margin-bottom: var(--space-0);
    align-items: flex-start;
  `)}
`;

export const Title = styled.h1`
  ${Typography.heading_md}
  color: var(--text-primary);
  margin: var(--space-0);
`;

export const TitleSection = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
`;

export const StatusIcon = styled.div`
  display: flex;
  width: 16px;
  height: 16px;
  .stroke-path {
    stroke: var(--text-placeholder);
  }
  .fill-path {
    fill: var(--text-placeholder);
  }
  .template-view-fill-color {
    fill: var(--text-placeholder);
  }
`;

export const Icon = styled.div`
  padding: var(--space-5);
  ${FlexCenter}
`;
